export default "__VITE_ASSET__4014df07__"